export default {
  title: 'A HUB',
  tips: {
    enable: 'Enable to show real-time battery in the Windows taskbar',
    disable: 'Disable to show the default A HUB icon in the Windows taskbar',
  },
  resetSize: 'Restore Window Size',
  update: 'Update Now',
  quit: 'Exit',
}
